import { Add, GroupAdd } from '@mui/icons-material';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Fab, Grid, TextField, Typography } from '@mui/material';
import axios from 'axios';
import React, { Component } from 'react';
import BuamaList from './BuamaList';
import ResponsiveCarousel from './Elements/ResponsiveCarousel';
import { Group, User } from './Types/Types';
interface Props {
    user: User | null
};
const formTemplate = {
    data: {
        shorthand: '',
        name: '',
        description: '',
    },
    errors: {},
};
class Groups extends Component<Props, {groups: Group[],groupId:number|null|undefined,members:User[],popup:boolean,form: any}> {
    constructor(props : Props) {
        super(props);
        const groupStr = localStorage.getItem('groups');
        const groups = JSON.parse(groupStr ?? '[]');

        const groupId = groups[0]?.id;

        let members = [];
        if (groupId) {
            const memberStr = localStorage.getItem('members-'+groupId);
            members = JSON.parse(memberStr ?? '[]');
        } else {
            members = [];
        }

        this.state={
            groups: groups,
            groupId: groupId,
            members: members,
            popup: false,
            form: formTemplate,
        };
    }
    

    componentDidMount() {
        this.load();
    }
    
    load = () => {
        axios.get<Group[]>('/groups')
            .then(res => {
                const groups = res.data;
                localStorage.setItem('groups', JSON.stringify(groups));
                this.setState({
                    groups: groups,
                });
            });
    }

    componentDidUpdate(prevProps : any, prevState : any) {
        if (prevState.groupId != this.state.groupId) {
            this.handleUpdateMembers();
        }
    }
    
    handleUpdateMembers = () => {
        axios.get<User[]>('/group/members/' + this.state.groupId)
            .then(res => {
                const members = res.data;
                localStorage.setItem('members-'+this.state.groupId, JSON.stringify(members));
                this.setState({
                    members: members,
                });
            });
    }

    handleOnActiveGroupChange = (activeGroupIndex : number) => {
        const { groups } = this.state;
        const group = groups[activeGroupIndex];
        this.setState({
            groupId: group.id,
        });
    }

    handleJoinGroup = (e: React.MouseEvent | null) => {
        axios.post('/group/join/' + this.state.groupId)
            .then(res => {
                this.handleUpdateMembers();
            });
    }

    handleOpenPopup = (e: React.MouseEvent | null) => {
        this.setState({
            popup: true,
            form: formTemplate,
        });
    }

    handleClosePopup = (e: any | null) => {
        this.setState({
            popup: false,
        });
    }

    handleSubmitPopup = (event : any) => {
        const { form } = this.state;

        axios.post('/group/create', form.data)
            .then(res => {  
                this.load();
                this.handleClosePopup(event);
            }).catch((err) => {
                const { form } = this.state;

                const errors = err.response.data.errors;

                this.setState({
                    form: {
                        data: form.data,
                        errors: errors,
                    }
                })
            });
    }

    handleOnInputChange = (event : any) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        const { data : currentData, errors } = this.state.form;
        let data = Object.assign({}, currentData);
        data[name] = value;

        this.setState({
            form: {
                errors: errors,
                data: data,
            }
        });
    }

    render() {
        const { groups, members, popup } = this.state;
        
        function Card (props : any) {
            const { data, dataIndex } = props;
            const group : Group = data[dataIndex];
            
            return (
              <div style={{
                width: "100%",
                height: 200,
                userSelect: "none",
                backgroundColor: "#313131",
                boxShadow: "0px 10px 10px 10px rgba(0, 0, 0, 0.5)",
                borderRadius: '5px',
                border: '1px solid rgba(255, 215, 0, 0.18)',
                display: "grid",
                placeItems: "center",
                textAlign: "center",
                overflow: 'hidden',
              }}>
                <div style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                  <div style={{ position: 'absolute', top: 0, left: 0, height: '100%', width: '100%', display: "grid", placeItems: "center" }}>
                    <div style={{ fontSize: '8em', fontWeight: 'bold', opacity: 0.15, textTransform: 'uppercase', color: '#FFD700' }}>{group.shorthand}</div>
                  </div>
                  <div style={{ fontSize: '3em', fontWeight: 'bold', overflow: 'hidden', textOverflow: 'ellipsis', color: '#FFFFFF' }}>{group.name}</div>
                  <div style={{ color: '#CCCCCC' }}>{group.description}</div>
                  <Grid container sx={{ marginTop: 2, fontWeight: 'bold' }}>
                    <Grid item xs={6}>
                        <div>Rang: {group.rank}</div>
                        <div>Beers: {group.total_beers??0}</div>                        
                    </Grid>
                    <Grid item xs={6}>
                        BPB: {(parseFloat(''+(group.average??0)).toFixed(1))}
                        <div style={{ fontSize: '0.75em', fontWeight: 'normal' }}>Bier per Bua</div>
                    </Grid>
                  </Grid>
                </div>
              </div>
            );
        }

        const getErrorText = (name : string) => {
            const { form } = this.state;

            if (form) {
                if (typeof form.errors !== 'undefined') {
                    if (typeof form.errors[name] !== 'undefined') {
                        return form.errors[name];
                    }
                }
            }
            return undefined;
        }

        const getError = (name : string) => {
            return getErrorText(name) ? true : false;
        }


        const createGroupDialog = <form> 
            <Dialog open={popup} onClose={(e) => this.handleClosePopup(e)} onSubmit={this.handleSubmitPopup}>
                <DialogTitle>Neue Gruppn</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Erstöh a neue Gruppn
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        name="shorthand"
                        error={getError('shorthand')}
                        helperText={getErrorText('shorthand')}
                        label="Abkürzung"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={this.handleOnInputChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="name"
                        error={getError('name')}
                        helperText={getErrorText('name')}
                        label="Gruppnnome"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={this.handleOnInputChange}
                    />
                    <TextField
                        autoFocus
                        margin="dense"
                        name="description"
                        error={getError('description')}
                        helperText={getErrorText('description')}
                        label="Spruch"
                        type="text"
                        fullWidth
                        variant="standard"
                        onChange={this.handleOnInputChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleClosePopup}>Agee decht nit.</Button>
                    <Button onClick={this.handleSubmitPopup}>Dastöhn</Button>
                </DialogActions>
        </Dialog>
      </form>;

        return (
            <React.Fragment>
                <Box sx={{ mt: 2 }}>
                    {groups.length > 0 && <ResponsiveCarousel items={groups} card={Card} onActiveSlideChange={(activeGroupIndex) => this.handleOnActiveGroupChange(activeGroupIndex)}/>}
                </Box>
                <Box sx={{ display: 'grid', placeItems: 'center', marginTop: -2.5, marginBottom: -2.5 }}>
                    <Fab
                        size="small"
                        color="primary"
                        onClick={(e) => this.handleOpenPopup(e)}
                        sx={{ borderRadius: '0.5em' }}
                    >
                        <Add />
                    </Fab>
                </Box>
                <Box sx={{ mt: 2 }}>
                    <Typography textAlign={'center'} variant={'h4'} sx={{ p: 2, paddingBottom: 0 }}>{"Mit-und-ohne-Glieder"}: {members.length}</Typography>
                    <Typography textAlign={'center'} variant={'body2'} sx={{ p: 2, paddingTop: 0 }}>Wea keascht wo dazua?!</Typography>
                </Box>
                <Divider />
                <Box flexGrow={1} flexBasis={'400px'}>
                    <BuamaList users={members} placeholderPrimary='No koa Bua dabei!' placeholderSecondary='I dat ma oa suachn.'/>
                </Box>
                <Divider/>
                <Box sx={{ display: 'grid', placeItems: 'center', p: 1 }}>
                    <Button variant={"contained"} onClick={this.handleJoinGroup} startIcon={<GroupAdd fontSize="inherit" />}>
                        Join se group 
                    </Button>
                </Box>
                {createGroupDialog}
            </React.Fragment>
        );
    }
}
export default Groups;